import React, { useState } from "react";
import { Button } from "@racoon/ui";
import { useTypedT, Namespace } from "@racoon/i18n";
import { ConnectProto } from "@racoon/api";
import { JobPickerSelectionStore, useJobPickerSelection } from "./job-picker-selection";

interface JobPickerModalFooterProps {
  selection: JobPickerSelectionStore;
  /** Label for the confirm button (defaults to "add to route"). */
  confirmLabel?: string;
  onConfirm: (jobIds: number[], jobs: ConnectProto.Job[]) => void | Promise<void>;
}

// Rendered as ModalProvider's `footer` — the provider already wraps it in
// <ModalFooter>, so this only supplies the actions.
export const JobPickerModalFooter: React.FC<JobPickerModalFooterProps> = ({
  selection,
  confirmLabel,
  onConfirm,
}) => {
  const t = useTypedT(Namespace.Routes);
  const selected = useJobPickerSelection(selection);
  // Confirming may re-issue missed jobs first; a second click must not re-issue twice.
  const [pending, setPending] = useState(false);

  const confirm = async () => {
    setPending(true);
    try {
      await onConfirm([...selected].map(Number), selection.getSelectedJobs());
    } finally {
      setPending(false);
    }
  };

  return (
    <Button
      size="sm"
      variant="opacityBlueWithOutline"
      disabled={selected.size === 0 || pending}
      onClick={confirm}
    >
      {confirmLabel ?? t("addToRoute")}
    </Button>
  );
};
